import React,{ useState, useEffect } from 'react';

import maison from "../../assets/images/maison.svg";
import {urlBase, urlDirectus} from "../../config/Globals";
import ArticleSevice from "../../service/Article";
import {Partenaires} from "../Home/Partenaires";

export const Connaitre = ({ rubrique }) => {

    const[articles, setArticles] = useState([]);
    const[loadingArticles, setLoadingArticles] = useState(1);
    const fetchArticles = async(id) => {
        try{
            const data = await ArticleSevice.findAllInRubrique(id);
            setArticles(data);
            setLoadingArticles(false);
        }catch (error){

        }
    }
    useEffect(() => {
        if(rubrique.id) {
            fetchArticles(rubrique.id);
        }
    }, [rubrique.id]);

    return (
        <>
            <main class="type connaitre-maladie">
                <section className="pt-md-5 pt-lg-0 pb-md-5 d-flex align-items-center">
                    <div className="bg-cover-3 d-none d-md-block"></div>
                    <div className="container-top-custom container-md px-md-4 pb-md-5 position-relative z-1">
                        <div className="row flex-column align-items-center justify-content-center">
                            <div className="col-12 col-lg-10 bg-white pb-5 p-4 p-md-5 position-relative">
                                <div className="col-12">
                                    <nav aria-label="breadcrumb" className="mb-4">
                                        <ol className="custom-breadcrumb">
                                            <li className="breadcrumb-item-custom">
                                                <a href={urlBase} className="breadcrumb-link-home">
                                                    <img src={maison} alt="Accueil" className="breadcrumb-icon"/>
                                                </a>
                                            </li>
                                            <li className="breadcrumb-separator">•</li>

                                            <li className="breadcrumb-item-custom">
                                                <a href={urlBase + 'tout-savoir-sur-la-flavescence-doree'}
                                                   className="breadcrumb-link">
                                                    Tout savoir sur la flavescence dorée
                                                </a>
                                            </li>

                                            <li className="breadcrumb-separator">•</li>

                                            <li className="breadcrumb-item-custom active" aria-current="page">
                                                {rubrique.titre}
                                            </li>
                                        </ol>
                                    </nav>
                                </div>

                                {
                                    articles.map((article, index) => (
                                            <>
                                                <div className="col-12 d-flex gap-3 align-items-center">
                                                    <h1 className="display-6 fw-sb mb-0">{article.titre}</h1>
                                                </div>
                                                <div
                                                    className="col-5 d-none d-xl-flex bg-beige align-items-center position-absolute end-0 top-0 translate-middle-y me-5 fw-b p-5 pb-4">
                                                    <div className="p-xxl-3">
                                                        <p>{article.encart_gris}</p>
                                                    </div>
                                                </div>
                                                <div className="col-12 mt-4"
                                                     dangerouslySetInnerHTML={{__html: article.contenu}}>

                                                </div>
                                            </>
                                        )
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </section>
                {
                    articles.map((article, index) => (
                        article.images &&
                        <section className="bg-gris pt-md-4 pb-5">
                            <div className="container pt-md-5 pb-5 mb-md-4">
                                <div className="row justify-content-center">
                                    <div className="col-12 col-lg-10 row g-5 m-0">
                                        <div className="col-12 col-lg-6 d-flex flex-column gap-5">
                                            <img src={article.images[0] && urlDirectus+"assets/"+article.images[0].item} alt={article.titre + " 1"} className="rounded-4 w-100 object-fit-cover" height="280"/>
                                            <img src={article.images[1] && urlDirectus+"assets/"+article.images[1].item} alt={article.titre + " 2"} className="rounded-4 w-100 object-fit-cover" height="280"/>
                                        </div>
                                        <div className="col-12 col-lg-6 d-flex flex-column gap-5 pt-5">
                                            <img src={article.images[2] && urlDirectus+"assets/"+article.images[2].item} alt={article.titre + " 3"} className="rounded-4 w-100 object-fit-cover" height="280"/>
                                            <img src={article.images[3] && urlDirectus+"assets/"+article.images[3].item} alt={article.titre + " 4"} className="rounded-4 w-100 object-fit-cover" height="280"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        )
                    )
                }
                <Partenaires/>
            </main>
        </>
    );
}